import { jsx as _jsx } from "react/jsx-runtime";
import { useActiveBrandTax } from '../network';
import { useApiQuery } from '../../../infra/api';
import { useRouteParams } from '../../../infra/routing';
import { endpoints as shopEndpoints } from '../../../shop/network';
import { useSession } from '../../../infra/session';
import { ShopAssignmentsContainer } from './shop-assignments.container';
import Loading from '../../../../app/main/customers/customersList/loading';
export var DataContainer = function () {
    var params = useRouteParams();
    var session = useSession().data;
    var brand = ((session === null || session === void 0 ? void 0 : session.view) || { viewer: null }).viewer;
    var brandShopsQuery = useApiQuery({
        endpoint: shopEndpoints.brandShopsQuery,
        payload: { brandId: brand.id },
        options: { enabled: !!brand },
    });
    // refetch on mount because we need to send the data from the tax's `taxable` field when updating shop assignments
    // since that field might be changes in the neighboring tabs of the form, making sure we have the latest data here
    var taxQuery = useActiveBrandTax(params.id, { refetchOnMount: true });
    if (!brandShopsQuery.data || !taxQuery.data) {
        return _jsx(Loading, {});
    }
    return _jsx(ShopAssignmentsContainer, { tax: taxQuery.data, shops: brandShopsQuery.data });
};
